import { render, staticRenderFns } from "./modalGestionarComision.vue?vue&type=template&id=13f44e62"
import script from "./modalGestionarComision.vue?vue&type=script&lang=js"
export * from "./modalGestionarComision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports